/**
 * Espejo del control de acceso del servidor (identity/access.js).
 * account admin ve todos los productos. dev también, salvo Seguridad.
 */

const OPS_LEVELS = ["customer", "technician", "scheduler", "supervisor", "rh"];
const CRM_LEVELS = ["manager", "agent", "marketer", "qualifier"];

const OPS = {
  customer: "customer",
  costumer: "customer",
  technician: "technician",
  scheduler: "scheduler",
  supervisor: "supervisor",
  rh: "rh",
};

const DEMO_ROLE_KEY = "trazia-demo-role";

export const DEMO_ROLES = [
  { id: "admin", label: "Administrador" },
  { id: "scheduler", label: "Agenda" },
  { id: "supervisor", label: "Supervisión" },
  { id: "rh", label: "Recursos humanos" },
  { id: "technician", label: "Técnico" },
  { id: "customer", label: "Cliente" },
];

export function readDemoRole() {
  try {
    const stored = localStorage.getItem(DEMO_ROLE_KEY);
    if (DEMO_ROLES.some((role) => role.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return "admin";
}

export function storeDemoRole(roleId) {
  try {
    localStorage.setItem(DEMO_ROLE_KEY, roleId);
  } catch {
    /* ignore */
  }
}

function cleanLevel(value, allowed) {
  if (value == null || value === "" || value === "none") return null;
  return allowed.includes(value) ? value : null;
}

export function resolveIdentity(user) {
  if (!user) return { account: "member", grants: { ops: null, crm: null }, status: "active" };

  const account = user.account === "admin" || user.account === "dev" || user.account === "member"
    ? user.account
    : "member";

  return {
    account,
    grants: {
      ops: cleanLevel(user.grants?.ops, OPS_LEVELS),
      crm: cleanLevel(user.grants?.crm, CRM_LEVELS),
    },
    status: user.status === "suspended" ? "suspended" : "active",
  };
}

function matches(identity, name) {
  if (name === "admin") return identity.account === "admin";
  if (name === "dev") return identity.account === "dev";
  if (name === "member") return identity.account === "member";
  if (name === "crm_manager") return identity.grants.crm === "manager";
  if (name === "crm_agent") return identity.grants.crm === "agent";
  if (name === "crm_marketer") return identity.grants.crm === "marketer";
  if (name === "crm_qualifier") return identity.grants.crm === "qualifier";
  if (OPS[name]) return identity.grants.ops === OPS[name];
  return false;
}

export function demoRoleSees(roles, demoRole = readDemoRole()) {
  if (demoRole === "admin") return roles.includes("admin");
  return roles.includes(demoRole);
}

function isSecurityOnly(allowedRoles = []) {
  return allowedRoles.length === 1 && allowedRoles[0] === "admin";
}

export function canAccess(user, allowedRoles = []) {
  const identity = resolveIdentity(user);
  if (identity.status === "suspended") return false;
  if (identity.account === "admin") return true;
  if (identity.account === "dev" && !isSecurityOnly(allowedRoles)) return true;
  return allowedRoles.some((name) => matches(identity, name));
}

/** Sin el pase de administrador. Sirve para entradas de menú de un solo producto. */
export function hasExactAccess(user, allowedRoles = []) {
  const identity = resolveIdentity(user);
  if (identity.status === "suspended") return false;
  if (identity.account === "dev" && !isSecurityOnly(allowedRoles)) return true;
  return allowedRoles.some((name) => matches(identity, name));
}

export function seesAllCrm(user) {
  const identity = resolveIdentity(user);
  if (identity.status === "suspended") return false;
  return identity.account === "admin" || identity.account === "dev" || identity.grants.crm === "manager";
}

export function hasCrm(user) {
  const identity = resolveIdentity(user);
  if (identity.status === "suspended") return false;
  return identity.account === "admin" || identity.account === "dev" || Boolean(identity.grants.crm);
}

export function crmLevel(user) {
  return resolveIdentity(user).grants.crm;
}

export function getDefaultRoute(user) {
  const identity = resolveIdentity(user);
  if (identity.account === "admin" || identity.account === "dev" || identity.grants.crm === "manager") return "/crm/admin";
  if (
    identity.grants.crm === "agent" ||
    identity.grants.crm === "marketer" ||
    identity.grants.crm === "qualifier"
  ) {
    return "/crm/ejecutivo";
  }
  return "/";
}
